// Filename - components/landing/InnovationFirst.js

import React from "react";
import { Container, Row, Col, Card, CardBody} from "react-bootstrap";
import { Link } from "react-router-dom";


export default function Blog (){


    return (
      <Container fluid className="p-5" style={{backgroundColor: '#eef6fe'}}>
         <Row className="mx-3 mt-3 mb-3">
            <h3 className="display-4">Blogs </h3>
            <p className="lead"> Hear from the innovation experts behind MindAntix, and how organizations can benefit from incorporating it.</p>
            
            <Col className="col-12 col-md-4 text-left">
               <Card className="border-warning">
                  <img className="card-img-top img-fluid"
                     src="images/blogs/HBR-Misconceptions.png"
                     style={{height:'15vw'}}
                     alt="Creativity Misconceptions"
                  />
                  <Card.Body className="text-white" style={{backgroundColor: '#aaaaaa'}}>
                     <Card.Title className="text-truncate"> 3 Common Fallacies About Creativity </Card.Title>
                     <Card.Text className="small">
                        Leaders often cite creativity and innovation as critical components of business success. But many businesses fail to create and encourage... 
                        <Link to="http://blog.mindantix.com/2017/09/how-neurodiversity-helps-in-creativity/" target="_blank" style={{color: '#c87137'}}>Continue Reading </Link> 
                     </Card.Text>
                  </Card.Body>
               </Card>           
            </Col> 

            <Col className="col-12 col-md-4 text-left">
               <Card className="border-warning">
                  <img className="card-img-top img-fluid"
                     src="images/blogs/Neurodiversity.png"
                     style={{height:'15vw'}}
                     alt="Neurodiversity"
                  />
                  <Card.Body className="text-white" style={{backgroundColor: '#aaaaaa'}}>
                     <Card.Title className="text-truncate"> How Neurodiversity Helps in Creativity </Card.Title>
                     <Card.Text className="small">
                        As a child, Isaac spoke little and had trouble reacting appropriately in social situations. He found it hard to form friendships and preferred...
                       <Link to="http://blog.mindantix.com/2017/09/how-neurodiversity-helps-in-creativity/" target="_blank" style={{color: '#c87137'}}>Continue Reading </Link> 
                     </Card.Text>
                  </Card.Body>
               </Card>           
            </Col>

            <Col className="col-12 col-md-4 text-left">
               <Card className="border-warning">
                  <img className="card-img-top img-fluid"
                     src="images/blogs/NeuroscienceCreativity.png"
                     style={{height:'15vw'}}
                     alt="Creativity Misconceptions"
                  />
                  <Card.Body className="text-white" style={{backgroundColor: '#aaaaaa'}}>
                     <Card.Title className="text-truncate"> The Neuroscience Of Creativity </Card.Title>
                     <Card.Text className="small">
                         A few hours after Einstein died, Thomas Harvey, the pathologist who performed his autopsy, removed Einstein’s brain without his family’s permission...
                         <Link to="http://blog.mindantix.com/2019/05/the-neuroscience-of-creativity/" target="_blank" style={{color: '#c87137'}}>Continue Reading </Link> 
                     </Card.Text>
                  </Card.Body>
               </Card>           
            </Col> 
         </Row>

         <Row className="mt-5 text-center">
         <p><Link className="btn btn-secondary" to="http://blog.mindantix.com" target ='_blank' role="button">Check out the MindAntix blog &raquo;</Link></p>

         </Row>

      </Container>
    )

}
